// extracted by mini-css-extract-plugin
export default {"ShopCheckoutCartTableImage":"ShopCheckoutCartTable_ShopCheckoutCartTableImage__mwMo0"};